import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import PdfViewer from "./pages/PdfViewer";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Error from "./components/error";
import PdfEditor from "./PdfEditor";
import Loader from "./components/loader";
import axios from "axios";
import env from "react-dotenv";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary";

/**
 * Bootstrap axios for ServiceNow API calls.
 */
(async () => {
  try {
    // Set API base URL (Express server). If omitted, the app uses same-origin relative paths.
    const apiBaseRaw = env.REACT_APP_API_BASE_URL;
    const apiBase = apiBaseRaw ? String(apiBaseRaw).replace(/\/+$/, "") : "";
    if (apiBase) {
      axios.defaults.baseURL = apiBase;
    }
    console.log("[Init] API base URL:", apiBase || "(same-origin)");

    // Initialize headers object for downstream axios calls
    if (!axios.defaults.headers) {
      axios.defaults.headers = {};
    }
  } catch (e) {
    console.error("[Init] Bootstrap error:", e);
  }
})();

const router = createBrowserRouter([
  {
    path: "/",
    element: <PdfEditor />,
  },
  {
    path: "/editor",
    element: <PdfEditor />,
  },
  {
    path: "/pdf-viewer",
    element: <PdfViewer />,
  },
  {
    path: "/error",
    element: <Error />,
  },
  {
    path: "/callback",
    element: <Loader />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GlobalErrorBoundary>
    <RouterProvider router={router} />
  </GlobalErrorBoundary>
);
